var newsSection = document.querySelector('.news-wrap')
const newssbody = document.getElementsByTagName('body')[0]

let newsItems = []

if (newsSection) {
  const searchClient = algoliasearch(
    'LKYK6WM342',
    'e6cda3824c0852f67eeed226fc7bb704',
  )

  const search = instantsearch({
    indexName: 'news',
    searchClient,
  })

  // search.start();

  search.addWidgets([
    instantsearch.widgets.searchBox({
      container: '#news_searchbox',
      placeholder: 'Search',
    }),
  ])
  //----------hits --------

  setTimeout(function () {
    search
      .addWidget(
        instantsearch.widgets.hits({
          container: '#news_hits',

          templates: {
            item: function (hit) {
              // if (hit.press_category == "In the News") {
              let linkk = `/${hit.search_api_id.split(':')[1]}`
              var temp
              var redirectionUrl = setRedirection(hit)
              let paragraphs = refinePara(hit.processed)
              let authDate = hit.created == undefined ? '' : hit.created
              temp = new Date(authDate * 1000).toDateString()
              let monthname = dateFormatter(temp.split(' ')[1])
              let date = `${monthname} ${temp.split(' ')[2]}, ${
                temp.split(' ')[3]
              }`
              var editLink = handleEdit(linkk)
              return `
            <div class="card">
             ${redirectionUrl}
             ${editLink !== undefined ? editLink : ''}
              <span>${date}</span>
              <h4>
              ${hit.name == undefined ? hit.title : hit.name}
              </h4>
              ${hit.processed == undefined ? '' : `<p>${paragraphs}</p>`}
            </div>
          `
              // }
            },
            empty: `<span>No result found for "{{query}}"`,
          },

          sortBy: ['created:desc'],
        }),
      )
      .on('render', function () {
        const hitsContainer = newsSection.querySelector('#news_hits')
        const child = hitsContainer.children[0]
        const listItemElements = hitsContainer.querySelectorAll('li')
        const div = document.createElement('div')
        listItemElements.forEach(function (li, index) {
          div.innerHTML += li.innerHTML
        })

        if (child !== undefined) {
          hitsContainer.replaceChild(div, child)
        }

        if (hitsContainer.children[1] != undefined) {
          if (listItemElements.length == 0) {
            hitsContainer.removeChild(hitsContainer.children[0])
          } else {
            hitsContainer.removeChild(hitsContainer.children[1])
          }
        }
      })
  }, 1200)

  //-----refine paragraph-----

  function refinePara(processed) {
    if (processed != undefined) {
      let paragraphs = processed.split('\n\n')
      let containsImages = paragraphs.some((paragraph) =>
        paragraph.includes('<img'),
      )

      let bodyHTML = ''
      bodyHTML = processed.replace(/<[^>]*>?/gm, '')

      return bodyHTML
    }
  }

  //------- redirecting post url
  function setRedirection(data) {
    let setUrl
    var domainName = window.location.hostname
    if (data.hasOwnProperty('field_url')) {
      if (data.field_url != "") {
        if (data.field_url.includes(domainName)) {
          setUrl = `<a href="${data.field_url}" class="empty-link">.</a>`
        } else {
          setUrl = `<a href="${data.field_url}" target="_blank" class="empty-link">.</a>`
        }
      }else {
        setUrl = `<a href="${data.url_1}" class="empty-link">.</a>`
      }
    } else {
      setUrl = `<a href="${data.url_1}" class="empty-link">.</a>`
    }
    return setUrl
  }

  search.addWidget(
    instantsearch.widgets.configure({
      hitsPerPage: 10,
      filters: 'press_category:"In the News"',
    }),
  )
  //------- add edit btn on login ----------

  function handleEdit(link) {
    if (newssbody.getAttribute('id') == 'admin-logged-in') {
      return `<a class="edit-link" href="${link}/edit/">[Edit]</a>`
    }
  }

  //---------- finantial year ----------

  search.addWidget(
    instantsearch.widgets.refinementList({
      container: '#news-year',
      attribute: 'finacial_year',
      limit: 1000,
      operator: 'or',
      searchable: true,
      sortBy: ['name:desc'],
      cssClasses: {
        root: 'MyCustomRefinementList1',
        list: ['list-wrap'],
      },
    }),
  )

  setTimeout(function () {
    search.on('render', function () {
      const yearFacetsCount = search.helper.getRefinements('finacial_year')
        .length

      var inputElement

      inputElement = newsSection.querySelectorAll(
        '.field-wrap .ais-SearchBox-input',
      )

      if (yearFacetsCount > 0) {
        inputElement[0].placeholder = `${yearFacetsCount} item selected`
      } else {
        inputElement[0].placeholder = `-Any-`
      }
    })
  }, 2000)

  //----- clear all
  search.addWidget(
    instantsearch.widgets.clearRefinements({
      container: '#reset-btn',
      templates: {
        resetLabel: 'Reset',
      },
    }),
  )

  //------- reset search
  newsSection
    .querySelector('#reset-btn')
    .addEventListener('click', function () {
      search.helper.setQuery('').search()
    })

  //--------- pagination ------------

  const customTemplates = {
    previous: ' ‹ Previous',
    next: 'Next › ',
  }
  

  search.addWidget(
    instantsearch.widgets.pagination({
      container: '#news_pagination',
      templates: customTemplates,
    }),
  )

  search.start()

  //-----------date formatter ------------
  function dateFormatter(dateVal) {
    let month = dateVal
    switch (month) {
      case 'Jan':
        return 'January'
      case 'Feb':
        return 'February'
      case 'Mar':
        return 'March'
      case 'Apr':
        return 'April'
      case 'May':
        return 'May'
      case 'Jun':
        return 'June'
      case 'Jul':
        return 'July'
      case 'Aug':
        return 'August'
      case 'Sep':
        return 'September'
      case 'Oct':
        return 'October'
      case 'Nov':
        return 'November'
      case 'Dec':
        return 'December'
      default:
        return 'foo'
    }
  }

  //----------------click----------------
  setTimeout(function () {
    var fields = newsSection.querySelectorAll('.field-wrap .custom-select')
    var itemlist = newsSection.querySelectorAll(
      '.ais-RefinementList  .list-wrap',
    )

    fields.forEach(function (item, index) {
      var input = item.querySelector('.ais-SearchBox-input')
      input.setAttribute('readOnly', 'true')
      input.placeholder = '-Any-'

      item.addEventListener('click', function () {
        if (item.classList.contains('active')) {
          item.classList.remove('active')
        } else {
          for (let i = 0; i < fields.length; i++) {
            fields[i].classList.remove('active')
          }
          item.classList.add('active')
        }
      })
    })

    document.addEventListener('click', function (e) {
      if (!e.target.classList.contains('ais-SearchBox-input')) {
        for (let i = 0; i < fields.length; i++) {
          fields[i].classList.remove('active')
        }
      } else {
        return
      }
    })
  }, 1800)
}
